
function modifyShopBtn() {
    var sheet = new CSSStyleSheet;
    // sheet.replaceSync( `button { color: pink !important; }`);
    // const host = document.querySelector('shop-pay-wallet-button')
    // host.shadowRoot.adoptedStyleSheets.push(sheet);
}

setTimeout(() => {
    modifyShopBtn()
}, 1500)

document.addEventListener('DOMContentLoaded', function() {
    findAndHideDefaultChatOpenBtn(10)
    customChatBtnListener()
})

function customChatBtnListener() {
    const chatBtn = document.querySelectorAll('.style-2-footer-customer-wrapper .chat-btn')
    if (chatBtn.length) {
        chatBtn.forEach(btn => {
            btn.addEventListener('click', function(event) {
                event.preventDefault();
                try {
                    const shopifyChatHost = document.querySelector('inbox-online-store-chat');
                    if (shopifyChatHost && shopifyChatHost.shadowRoot) {
                    const closeBtn = shopifyChatHost.shadowRoot.querySelector(".chat-app--close-button")
                    if(closeBtn) {
                        closeBtn.click()
                    }
                    const chatToggleButton = shopifyChatHost.shadowRoot.querySelector('button.chat-toggle');
                    if (chatToggleButton) {
                        chatToggleButton.click();
                        chatToggleButton.style.display = 'none'
                    } else {
                        console.error('Shopify Inbox: Internal chat toggle button not found.');
                    }
                    } else {
                    console.error('Shopify Inbox: Chat host element not found or shadowRoot not accessible.');
                    }
                } catch (error) {
                    console.error('Error programmatically opening Shopify Inbox:', error);
                }
            });
        });
    }
}

function findAndHideDefaultChatOpenBtn(maxTries = 10) {
  let attempts = 0;

  const interval = setInterval(() => {
    try {
      attempts++;
      // Safely try to get the chat host element
      let shopifyChatHost;
      try {
        shopifyChatHost = document.querySelector('inbox-online-store-chat');
      } catch (err) {
        console.warn('Error accessing chat host:', err);
        shopifyChatHost = null;
      }

      // Agar element hi nahi mila toh skip karo
      if (!shopifyChatHost || !shopifyChatHost.shadowRoot) {
        if (attempts >= maxTries) {
          console.log(`Chat host not found after ${maxTries} attempts`);
          clearInterval(interval);
        }
        return;
      }

      // Shadow DOM me style inject karte waqt safety
      try {
        const style = document.createElement('style');
        style.innerHTML = 'button.chat-toggle { display: none !important; }';
        shopifyChatHost.shadowRoot.appendChild(style);
      } catch (err) {
        console.warn('Error injecting style in shadowRoot:', err);
      }

      // Button element safely check karo
      let element = null;
      try {
        element = shopifyChatHost.shadowRoot.querySelector('button.chat-toggle');
      } catch (err) {
        console.warn('Error querying button inside shadowRoot:', err);
      }

      if (element) {
        try {
          element.style.display = 'none';
          console.log(`✅ Element found and hidden after ${attempts} attempts`);
          clearInterval(interval);
          return true;
        } catch (err) {
          console.warn('Error hiding element:', err);
        }
      }

      // Retry limit check
      if (attempts >= maxTries) {
        console.log(`❌ Element not found after ${maxTries} attempts`);
        clearInterval(interval);
        return false;
      }
    } catch (err) {
      console.error('Unexpected error in findAndHideDefaultChatOpenBtn:', err);
      clearInterval(interval);
    }
  }, 200); // Check every 200ms
}

document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation on document
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('pre-order-btn') || e.target.closest('.pre-order-btn')) {
      e.preventDefault();
      console.log("pre-order-btn clicking...")
      var orderBtn
      if(e.target.classList.contains('pre-order-btn')) {
        orderBtn = e.target
      } else {
        orderBtn = e.target.closest('.pre-order-btn')
      }
      // Find the closest dialog overlay
      const prodId = orderBtn.getAttribute('data-product')
      const dialogOverlay = document.querySelector('.dialog-overlay.product-'+prodId);
      
      if (!dialogOverlay) return;
      
      const dialogBox = dialogOverlay.querySelector('.pre-order #dialogBox');
      
      // Update image if variant exists
      if(window.currentVariant) {
        const img = dialogOverlay.querySelector('img');
        if (img) {
          img.setAttribute('src', window.currentVariant.featured_image.src);
        }
      }
      
      // Get quantity and variant ID
      const form = e.target.closest('form');
      const qty = form.querySelector('.quantity__input')?.value ?? 1;
      const variantId = form.querySelector('[name="id"]').value;
      
      // Set values in dialog
      const qtyInput = dialogOverlay.querySelector('[name="quantity"]');
      const idInput = dialogOverlay.querySelector('[name="id"]');
      
      if (qtyInput) qtyInput.value = qty;
      if (idInput) idInput.value = variantId;
      
      dialogOverlay.classList.add('active');
    }
  });

  // Close dialog when clicking outside (delegated)
  document.addEventListener('click', (e) => {
    if (e.target.id === 'preOrderDialogOverlay' && e.target.classList.contains('active')) {
      e.target.classList.remove('active');
    }
  });

  // Prevent closing when clicking inside dialog box (delegated)
  document.addEventListener('click', (e) => {
    if (e.target.closest('.pre-order #dialogBox')) {
      e.stopPropagation();
    }
  });

  // Handle preorder button clicks (delegated)
  document.addEventListener('click', (e) => {
    if (e.target.id === 'preorderBtn' || e.target.closest('#preorderBtn')) {
      const dialogOverlay = e.target.closest('#preOrderDialogOverlay');
      
      if (dialogOverlay) {
        const qty = dialogOverlay.querySelector('[name="quantity"]')?.value;
        const variantid = dialogOverlay.querySelector('[name="id"]')?.value;
        
        // Do something with qty and variantid here
        
        //dialogOverlay.classList.remove('active');
      }
    }
  });

  // Close with Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const activeDialogs = document.querySelectorAll('#preOrderDialogOverlay.active');
      activeDialogs.forEach(dialog => {
        dialog.classList.remove('active');
      });
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('close-pre-order-dialog') || e.target.closest('.close-pre-order-dialog')) {
      const main = e.target.closest('#preOrderDialogOverlay')
      if(main) main.classList.remove('active')
    }
  });
});

// document.addEventListener('DOMContentLoaded', function() {
//   const dialogOverlay = document.getElementById('preOrderDialogOverlay');
//   const dialogBox = document.querySelector('.pre-order #dialogBox');
//   const preorderBtn = document.getElementById('preorderBtn');
  
//   // Use event delegation on document or a closer parent element
//   document.addEventListener('click', function(e) {
//     if (e.target.classList.contains('pre-order-btn')) {
//       e.preventDefault()
//       if(window.currentVariant) {
//         dialogOverlay.querySelector('img').setAttribute('src', window.currentVariant.featured_image.src)
//       }
//       const qty = e.target.closest('form').querySelector('.quantity__input')?.value ?? 1
//       const variantId = e.target.closest('form').querySelector('[name="id"]').value
//       dialogOverlay.querySelector('[name="quantity"]').value = qty
//       dialogOverlay.querySelector('[name="id"]').value = variantId
//       dialogOverlay.classList.add('active');
//     }
//   });

//   // Close dialog when clicking outside
//   dialogOverlay.addEventListener('click', (e) => {
//     if (e.target === dialogOverlay) {
//       dialogOverlay.classList.remove('active');
//     }
//   });

//   // Prevent closing when clicking inside dialog box
//   dialogBox.addEventListener('click', (e) => {
//     e.stopPropagation();
//   });

//   preorderBtn.addEventListener('click', () => {
//     const qty = dialogOverlay.getAttribute('data-quantity')
//     const variantid = dialogOverlay.getAttribute('data-id')
//     dialogOverlay.classList.remove('active');
//   });

//   // Close with Escape key
//   document.addEventListener('keydown', (e) => {
//     if (e.key === 'Escape' && dialogOverlay.classList.contains('active')) {
//       dialogOverlay.classList.remove('active');
//     }
//   });
// });

$(document).ready(function(){
      setTimeout(() => {
        const sections = document.querySelectorAll('.sourdough-cheat-sheet .shopify-section');

        if (!sections.length) {
          console.warn('No sections found — selector issue');
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              console.log('Viewport mein aaya:', entry.target.id);
              if(entry.target.id == 'shopify-section-template--19321033949337__funnel_question_K7GQia'){
                $('#shopify-section-template--19321033949337__funnel_question_K7GQia').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19321033949337__funnel_question_full_V7nQEe') {
                $('#shopify-section-template--19321033949337__funnel_question_full_V7nQEe').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19267616702617__funnel_page_yJ7EmP') {
                $('#shopify-section-template--19267616702617__funnel_page_yJ7EmP').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19321033949337__video_slider_product_ft6Tjt'){
                $('#shopify-section-template--19321033949337__video_slider_product_ft6Tjt').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19321033949337__funnel_question_only_title_87KnyE') {
                $('#shopify-section-template--19321033949337__funnel_question_only_title_87KnyE').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19321033949337__funnel_question_only_title_87KnyE') {
                $('#shopify-section-template--19321033949337__funnel_question_only_title_87KnyE').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19321033949337__funnaltitle_only_WjTbDL') {
                $('#shopify-section-template--19321033949337__funnaltitle_only_WjTbDL').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19321033949337__funnel_bakers_bctD7b') {
                $('#shopify-section-template--19321033949337__funnel_bakers_bctD7b').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19321033949337__funnel_round_rBwdYF'){
                $('#shopify-section-template--19321033949337__funnel_round_rBwdYF').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19321033949337__collapsible_content_mpjiip'){
                $('#shopify-section-template--19321033949337__collapsible_content_mpjiip').addClass('active');
              }
            }
          });
        }, {
          threshold: 0.2,
          rootMargin: '0px 0px -20% 0px'
        });

        sections.forEach(section => observer.observe(section));
      }, 300);

    $('.scroll-fade-text').each(function () {
      const $el2 = $(this);
      const text2 = $el2.text().trim();
      const words2 = text2.split(' ');

      let html2 = '';
      words2.forEach(word2 => {
        html2 += `<span class="word">${word2}</span> `;
      });

      $el2.html(html2);
    });

    const $el = $('.step_main .steps');
    const $bottomInner = $('.ovenCardBelow .oven-btn');
    if ($el.length) {

      const elementBottom = $el.offset().top + $el.outerHeight();
      const isMobile = window.innerWidth <= 767;

      const extraOffset = isMobile ? -200 : 50;
      const hideParalax = isMobile ? 750 : 1000;

      const elementBottomInner =  $bottomInner.offset().top + $bottomInner.outerHeight() + extraOffset;
      $(window).on('scroll', function () {
        if ($(this).scrollTop() >= hideParalax) {
          $('.paralaxImageBack').addClass('hide');
        } else {
          $('.paralaxImageBack').removeClass('hide');
        }

        const viewportBottom = $(window).scrollTop() + $(window).height();

        if (viewportBottom >= elementBottom) {
          $('.step_main .steps').addClass('active');
        }else {
          $('.step_main .steps').removeClass('active');
        }

        if (viewportBottom >= elementBottomInner) {
          $('.step_main .steps').addClass('fadeInMine');
        }else {
          $('.step_main .steps').removeClass('fadeInMine');
        }

        //Line animate
        const scrollTop1 = $(window).scrollTop();
        const winHeight1 = $(window).height();

        $('.scroll-fade-text').each(function () {

          const $text1 = $(this);
          const $words1 = $text1.find('.word');

          const elTop1 = $text1.offset().top;
          const elHeight1 = $text1.outerHeight();

          // START → element viewport mein aate hi
          const start1 = elTop1 - winHeight1;

          const endOffset = winHeight1 * 0.15;
          const end1 = elTop1 - endOffset;

          let baseProgress1 =
            (scrollTop1 - start1) / (end1 - start1);

          baseProgress1 = Math.max(0, Math.min(1, baseProgress1));

          const totalWords1 = $words1.length;

          $words1.each(function (i1) {

            const wordProgress1 = baseProgress1 * totalWords1 - i1;
            const clamped1 = Math.max(0, Math.min(1, wordProgress1));

            const minOpacity1 = 0.2;
            const maxOpacity1 = 1;

            const opacity1 =
              minOpacity1 + (maxOpacity1 - minOpacity1) * clamped1;

            $(this).css(
              'color',
              `rgba(200, 87, 45, ${opacity1})`
            );

          });

        });


      });

    }

    $('body').on('click', '.step-circles .circle', function(){
      var text = $(this).text();
      $('.step-circles .circle').removeClass('active');
      $(this).addClass('active');
      $('html, body').animate({
        scrollTop: $('.badge[data-id="'+text+'"]').offset().top - 100
      }, 600);
    });

    $('body').on('click', '.product__media.mmmm', function(){
      $(this).parent().find('button').click();
    });

    $('body').on('click', '.shopItemMine a', function(){
      var a = $(this).attr('data-id');
      console.log(a);
      $('html, body').animate({
        scrollTop: $('.oven-card[data-id="'+a+'"]').offset().top - 100
      }, 600);
    });
    
    $('body').on('click', '.quick-add-modal .content-tabs__tab', function(e){
        e.preventDefault();
        $('.quick-add-modal .content-tabs__tab').removeClass('content-tabs__tab--active');
        $('.quick-add-modal .content-tabs__content').removeClass('content-tabs__content--active');
        var getId = $(this).attr('data-content-tab-id');
        $('.quick-add-modal .content-tabs__tab[data-content-tab-id="'+getId+'"]').addClass('content-tabs__tab--active');
        $('.quick-add-modal .content-tabs__content[data-content-tab-id="'+getId+'"]').addClass('content-tabs__content--active');
    });

    $('body').on('click', '.drawer__header-close', function(){
      $('body').removeClass('overflow-hidden');
    });

    $('body').on("click", "#CartDrawer-Overlay", function () {
      $("cart-drawer.drawer").removeClass("active");
      $("body").removeClass("overflow-hidden");
    });

    $('body').on('click', '.variantImageSlider .swiper-slide', function(){
        var index = $(this).attr('data-index');
        if (window.mainSwiperPop && window.mainSwiperPop.slideTo) {
            window.mainSwiperPop.slideTo(index); // 3rd slide pe jump karega
        }
        $('.proImageSliderVariant').removeClass('hide');
    });

    $('body').on('click', '.popVariantClose', function(){
        $('.proImageSliderVariant').addClass('hide');
    });

    $('.video-slider .mineBtnMine').click(function(e){
        e.preventDefault();
        if($(this).hasClass('swiper-button-prev')){
            $('.products-tabs__layout .products-tabs-custom[aria-label="Previous slide"]').click();
            if($('.products-tabs__layout .products-tabs-custom[aria-label="Previous slide"]').hasClass('swiper-button-disabled')){
                $(this).addClass('disableMine');
            }else{
                $(this).removeClass('disableMine');
            }
            if($('.products-tabs__layout .products-tabs-custom[aria-label="Next slide"]').hasClass('swiper-button-disabled')){
                $('.mineBtnMine.swiper-button-next').addClass('disableMine');
            }else{
                $('.mineBtnMine.swiper-button-next').removeClass('disableMine');
            }
        }else{
            $('.products-tabs__layout .products-tabs-custom[aria-label="Next slide"]').click();
            if($('.products-tabs__layout .products-tabs-custom[aria-label="Next slide"]').hasClass('swiper-button-disabled')){
                $(this).addClass('disableMine');
            }else{
                $(this).removeClass('disableMine');
            }
            if($('.products-tabs__layout .products-tabs-custom[aria-label="Previous slide"]').hasClass('swiper-button-disabled')){
                $('.mineBtnMine.swiper-button-prev').addClass('disableMine');
            }else{
                $('.mineBtnMine.swiper-button-prev').removeClass('disableMine');
            }
        }
    });

    $('#insta-feed h2').wrapAll('<div class="instaWrapHeader"></div>');

    var widthWindow = $(window).width();

    if(widthWindow > 768){
        $('body').on('click', '.wheelPop', function(){
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'SaQKP4']);
        });
    }else{
        $('body').on('click', '.wheelPop', function(){
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'WkrmxQ']);
        });
    }

    $('body').on('mouseover', '.hoverImgMine', function(){
      if($(this).parents('.card--product').find('.mineHoverEffect .secImage').length){
        $(this).parents('.card--product').find('.mineHoverEffect .firstImage').attr('style', 'opacity: 0 !important;');
        $(this).parents('.card--product').find('.mineHoverEffect .secImage').attr('style', 'opacity: 1 !important;');
      }
    });

    $('body').on('mouseleave', '.hoverImgMine', function(){
      if($(this).parents('.card--product').find('.mineHoverEffect .secImage').length){
        $(this).parents('.card--product').find('.mineHoverEffect .firstImage').attr('style', 'opacity: 1 !important;');
        $(this).parents('.card--product').find('.mineHoverEffect .secImage').attr('style', 'opacity: 0 !important;');
      }
    });

    $('body').on('click', '.product-parameters .product-form__controls-group label', function(){
      var titleMine = $(this).attr('title');
      var _this = $(this).parents('.collection-products-grid__item');
      $(this).parents('.collection-products-grid__item').find('.variantMineImages .variantDataImages').each(function(){
        var getTitle = $(this).attr('data-variant');
        if(titleMine == getTitle){
          var frontImage = $(this).attr('frontimage');
          var hoverImage = $(this).attr('hoverimage');
          if(frontImage.indexOf('no-image') > -1){
            //nothing to do
          }else{
            _this.find('.mineHoverEffect').empty();
            _this.find('.mineHoverEffect').append('<img src="'+frontImage+'" class="firstImage" />');
            if(hoverImage.indexOf('no-image') > -1){
              //nothing to do
            }else{
              _this.find('.mineHoverEffect').append('<img src="'+hoverImage+'" class="secImage" dfdf />');
            }
          }
          return false;
        }
      });
    });

    // $('.template-product .product__media-item').mouseover(function(){
    //   if($(this).find('.secImage').length){
    //     var getSrc = $(this).find('.secImage').attr('src');
    //     if(getSrc.indexOf('no-image') > -1){
    //       //nothing to do
    //     }else{
    //       $(this).find('img:nth-child(1)').attr('style', 'opacity: 0 !important;');
    //       $(this).find('img:nth-child(2)').attr('style', 'opacity: 1 !important;');
    //     }
    //   }
    // });

    // $('.template-product .product__media-item').mouseleave(function(){
    //   if($(this).find('.secImage').length){
    //     var getSrc = $(this).find('.secImage').attr('src');
    //     if(getSrc.indexOf('no-image') > -1){
    //       //nothing to do
    //     }else{
    //       $(this).find('img:nth-child(1)').attr('style', 'opacity: 1 !important;');
    //       $(this).find('img:nth-child(2)').attr('style', 'opacity: 0 !important;');
    //     }
    //   }
    // });

    var checkBundleClass = $('body').hasClass('template-product-bundleRaw');
    if(checkBundleClass){
      var makeVariantValue = '';
      var getCount = $('variant-radios fieldset').length;
      $('variant-radios fieldset').each(function(index){
        var getVariant = $(this).find('.product-form__controls-group input:checked').val();
        if(index == getCount - 1){
          makeVariantValue += getVariant;
        }else {
          makeVariantValue += getVariant+' / ';
        }
      });

      var getImage = $('.variantImageMineColl[data-title="'+makeVariantValue+'"]').attr('frontbundle');

      // To change the main image
      $('.product__media-list-wrapper .product__media-list-container .product__media-item:nth-child(1) .product__media img').remove();
      $('.product__media-list-wrapper .product__media-list-container .product__media-item:nth-child(1) .product__media').append('<img src="'+getImage+'" class="firstImage" />');

      //To change the pop images
      $('.minePopModel .swiper-wrapper .product-media-modal__item:nth-child(1) img').remove();
      $('.minePopModel .swiper-wrapper .product-media-modal__item:nth-child(1) .swiper-zoom-container').append('<img src="'+getImage+'" class="popImageMine" />');

      // To change the thumbnails
      $('.product__media-sublist-outer .product__media-sublist-container .product__media-subitem:nth-child(1) .product__media img').remove();
      $('.product__media-sublist-outer .product__media-sublist-container .product__media-subitem:nth-child(1) .product__media').append('<img src="'+getImage+'" class="firstSubImage" />');

      $('body').on('click', '.color-swatch', function(){
        var makeVariantValue = '';

        setTimeout(function(){
          var getCount = $('variant-radios fieldset').length;

          $('variant-radios fieldset').each(function(index){
            var getVariant = $(this).find('.product-form__controls-group input:checked').val();

            if(index == getCount - 1){
              makeVariantValue += getVariant;
            } else {
              makeVariantValue += getVariant+' / ';
            }
          });

          var getImage = $('.variantImageMineColl[data-title="'+makeVariantValue+'"]').attr('frontbundle');

          // MAIN IMAGE
          var $mainImg = $('.product__media-item:nth-child(1) .product__media img');

          // $mainImg.fadeOut(200, function(){

          //   var newImg = new Image();
          //   newImg.src = getImage;

          //   newImg.onload = function(){
          //     $mainImg.attr('src', getImage).fadeIn(200);
          //   };

          // });
          $mainImg.attr('src', getImage);
          $mainImg.css({ opacity: '', transition: '' });
          $('.minePopModel .swiper-wrapper .product-media-modal__item:nth-child(1) img').remove();
          $('.minePopModel .swiper-wrapper .product-media-modal__item:nth-child(1) .swiper-zoom-container').append('<img src="'+getImage+'" class="popImageMine" />');

          // THUMBNAIL
           var $thumbImg = $('.product__media-subitem:nth-child(1) .product__media img');

          // $thumbImg.fadeOut(200, function(){

          //   var newThumb = new Image();
          //   newThumb.src = getImage;

          //   newThumb.onload = function(){
          //     $thumbImg.attr('src', getImage).fadeIn(200);
          //   };

          // });
          $thumbImg.attr('src', getImage);
          $thumbImg.css({ opacity: '', transition: '' });
          // SWIPER RESET
          var mySwiper = document.querySelector('.product__media-list').swiper;
          mySwiper.slideTo(0);

          var mySwiper2 = document.querySelector('.product__media-sublist').swiper;
          mySwiper2.slideTo(0);

          // MOBILE SCROLL
          if (window.innerWidth <= 768) {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }

        }, 100);
      });
        const updateBundleVariantImage = () => {
        let makeVariantValue = '';
        const getCount = $('variant-radios fieldset').length;

        $('variant-radios fieldset').each(function(index){
          const getVariant = $(this).find('.product-form__controls-group input:checked').val();

          if(index == getCount - 1){
            makeVariantValue += getVariant;
          } else {
            makeVariantValue += getVariant+' / ';
          }
        });

        const getImage = $('.variantImageMineColl[data-title="'+makeVariantValue+'"]').attr('frontbundle');
        if (!getImage) return;

        $('.product__media-item:nth-child(1) .product__media img').attr('src', getImage);
        $('.minePopModel .swiper-wrapper .product-media-modal__item:nth-child(1) img').remove();
        $('.minePopModel .swiper-wrapper .product-media-modal__item:nth-child(1) .swiper-zoom-container').append('<img src="'+getImage+'" class="popImageMine" />');
        $('.product__media-subitem:nth-child(1) .product__media img').attr('src', getImage);

        const mySwiper = document.querySelector('.product__media-list')?.swiper;
        if (mySwiper) mySwiper.slideTo(0);
      };

      $('body').on('change', '.product-form__controls-group input[type="radio"]', function(){
        updateBundleVariantImage();
      })
    }
});